export default class DateUtil {

    public static formatoPadraoDateInput = {
        parse: {
            dateInput: 'DD/MM/YYYY',
        },
        display: {
            dateInput: 'DD/MM/YYYY',
            monthYearLabel: 'MMM YYYY',
            dateA11yLabel: 'LL',
            monthYearA11yLabel: 'MMMM YYYY',
        },
    };

    public static isDataAtualizacaoBefore(dataAtualizacao: any, dataReferencia: Date): boolean {
        const [dia, mes, anoHora] = dataAtualizacao.split('/');
        const [ano, hora] = anoHora.split(' ');
        const [horas, minutos, segundos] = hora.split(':');
        const dataAtualizacaoDate = new Date(
            Number(ano),
            Number(mes) - 1,
            Number(dia),
            Number(horas),
            Number(minutos),
            Number(segundos)
        );
        return dataAtualizacaoDate < dataReferencia;
    }
}
